var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SetPassword',{attrs:{"title":_vm.title,"submit-btn-title":_vm.submitBtnTitle,"message":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }